import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function ContactUs() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        subject: '',
        message: '',
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // WhatsApp Number
        const whatsappNumber = "94775761468";

        // Pre-filled message
        const message = `Hello, I would like to get in touch.\n\n👤 Name: ${formData.name}\n📞 Phone: ${formData.phone}\n✉️ Email: ${formData.email}\n📌 Subject: ${formData.subject}\n📝 Message: ${formData.message}`;

        // Encode message for URL
        const encodedMessage = encodeURIComponent(message);

        // WhatsApp URL
        const whatsappURL = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

        // Open WhatsApp
        window.open(whatsappURL, '_blank');

        // Reset Form
        setFormData({
            name: '',
            phone: '',
            email: '',
            subject: '',
            message: '',
        });
    };

    return (
        <div className="container my-5">
            <div className="text-center mb-4">
                <h1 className="fw-bold" style={{ color: '#819371', fontSize: '2.5em' }}>FEEL FREE TO CONTACT US</h1>
            </div>

            <div className="row">
                <div className="col-md-6 mx-auto">
                    <form onSubmit={handleSubmit} className="p-4 border rounded bg-light shadow">
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Your Name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <input
                                type="tel"
                                className="form-control"
                                name="phone"
                                placeholder="Your Phone"
                                value={formData.phone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                placeholder="Your Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                name="subject"
                                placeholder="Subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="mb-3">
                            <textarea
                                className="form-control"
                                name="message"
                                placeholder="Your Message"
                                value={formData.message}
                                onChange={handleChange}
                                rows="4"
                                required
                            ></textarea>
                        </div>
                        <div className="mb-3 form-check">
                            <input type="checkbox" className="form-check-input" id="terms" required />
                            <label className="form-check-label" htmlFor="terms">I accept the Terms and Conditions</label>
                        </div>
                        <button type="submit" className="btn w-100" style={{ backgroundColor: '#819371', borderColor: '#819371', color: '#fff' }}>SEND YOUR MESSAGE NOW</button>
                    </form>
                </div>
            </div>

            <div className="text-center mt-5">
                <h3 className="fw-bold" style={{ color: '#819371', fontSize: '2em' }}>CINNAMON MANTRA LUXURY VILLA & AYURVEDA SPA</h3>
                <p style={{ fontSize: '1.5em' }}>221, 7th Lane, Moragalla, Beruwala</p>
                <p style={{ fontSize: '1.5em' }}>Tel: <a href="tel:+94775761468" className="text-decoration-none text-dark">+94 77 576 1468</a></p>
                <p style={{ fontSize: '1.5em' }}>Tel: <a href="tel:+94769072745" className="text-decoration-none text-dark">+94 76 907 2745</a></p>
                <p style={{ fontSize: '1.5em' }}>Email: <a href="mailto:cinnamonmantra@gmail.com" className="text-decoration-underline" style={{ color: '#819371' }}>cinnamonmantra@gmail.com</a></p>
            </div>

            <div className="text-center" style={{ marginTop: '40px' }}>
                <h2 className="fw-bold" style={{ color: '#819371', fontSize: '2em' }}>Our Location</h2>
                <iframe
                    title="Location Map"
                    src="https://maps.google.com/maps?q=6.423317,79.995241&t=&z=15&ie=UTF8&iwloc=&output=embed"
                    width="100%"
                    height="400"
                    frameBorder="0"
                    style={{ borderRadius: '10px', border: '0' }}
                    allowFullScreen
                ></iframe>
            </div>
        </div>
    );
}

export default ContactUs;